import React from 'react';
import PropTypes from 'prop-types';

const TrashcanIcon = () => (
  <svg className="trash-icon" width={24} height={27} viewBox="0 0 24 27" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M.335 1.284a1 1 0 011-1h21.088a1 1 0 010 2H1.335a1 1 0 01-1-1zm19.813 6.664H3.614L5.446 24.43H18.34l1.807-16.483zm-16.534-2a2 2 0 00-1.988 2.22l1.832 16.484a2 2 0 001.988 1.78H18.34a2 2 0 001.988-1.783l1.807-16.484a2 2 0 00-1.988-2.217H3.614zm14.366 5.9a.984.984 0 00-.862-1.11 1.016 1.016 0 00-1.13.866l-1.213 8.927a.984.984 0 00.861 1.11c.55.066 1.056-.321 1.13-.867l1.214-8.927zm-9.892 9.797a.996.996 0 01-1.123-.855l-1.189-8.93a1.004 1.004 0 01.86-1.126.996.996 0 011.123.855l1.189 8.93a1.004 1.004 0 01-.86 1.126zm4.79-9.956a1 1 0 10-2 0v8.757a1 1 0 102 0V11.69z"
      fill="#fff"
    />
  </svg>
);

TrashcanIcon.propTypes = {};

export default TrashcanIcon;
